// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { RegistrarService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { InstrumentConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/Instrument';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useArchiveInstrumentConfiguration: () => UseMutationResult<
  void,
  string,
  {
    registrarServiceCid: ContractId<RegistrarService>;
    instrumentConfigurationCid: ContractId<InstrumentConfiguration>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['archiveInstrumentConfiguration', ledgerApi],
    mutationFn: async ({ registrarServiceCid, instrumentConfigurationCid }) => {
      return ledgerApi.archiveRegistryInstrumentConfiguration(
        registrarServiceCid,
        instrumentConfigurationCid,
      );
    },
  });
};

export default useArchiveInstrumentConfiguration;
